import { CityController } from '@/business/modules/city';

const USER_SELECTED_CITY_FLAG = '__userSelectedCity';
const CITY_SOURCE_FIELD = '__citySource';
const CITY_SOURCE_SELECTED = 'selected';
const CITY_SOURCE_DEFAULT = 'default';
const DEFAULT_CITY = {
	id: 0,
	faName: 'همه شهرها',
	alternatives: ['all'],
	key: 'all',
};

const hasCityName = (city) => !!city?.faName;

const normalizeCity = (city, source) => ({
	...city,
	[CITY_SOURCE_FIELD]: source,
	[USER_SELECTED_CITY_FLAG]: source === CITY_SOURCE_SELECTED,
});

const actions = {
	getInstance() {
		return new CityController();
	},

	getCities() {
		return this.getInstance().getCities();
	},

	setCity(city) {
		this.city = city ? normalizeCity(city, CITY_SOURCE_SELECTED) : {};
	},

	hasUserSelectedCity() {
		if (!hasCityName(this.city)) return false;
		if (this.city?.[CITY_SOURCE_FIELD] === CITY_SOURCE_SELECTED || this.city?.[USER_SELECTED_CITY_FLAG]) return true;

		return !this.city?.[CITY_SOURCE_FIELD] && this.city?.key !== DEFAULT_CITY.key;
	},

	getActiveCity(userCity) {
		void userCity;
		if (this.hasUserSelectedCity()) return this.city;

		return normalizeCity(DEFAULT_CITY, CITY_SOURCE_DEFAULT);
	},

	syncActiveCity(userCity) {
		const activeCity = this.getActiveCity(userCity);
		if (this.city?.id === activeCity?.id && this.city?.faName === activeCity?.faName && this.city?.[CITY_SOURCE_FIELD] === activeCity?.[CITY_SOURCE_FIELD]) {
			return this.city;
		}

		this.city = activeCity;
		return this.city;
	},
};

export default actions;
